import { InputSwitch } from '@creditornot/cb-switch';
import React from 'react';
import styled from 'styled-components';

type Props = { isOpen: boolean; onChange: () => void };

const Container = styled.div`
  display: flex;
  margin-inline-end: 8px;
`;

const StyledInputSwitch = styled(InputSwitch)`
  margin-inline-end: 8px;
`;

const OpenCloseSwitch = ({ isOpen, onChange }: Props) => {
  return (
    <Container>
      <StyledInputSwitch checked={isOpen} onChange={onChange} />
      {isOpen ? <span>Open</span> : <span>Closed</span>}
    </Container>
  );
};

export default OpenCloseSwitch;
